import type { HawkEvent } from '../analytics-library/entry/sendEvent';
import type {
  ProcessedWidget,
  processWidget,
} from '../assets/modules/hawk/processWidgets/processWidget';
import type { renderWidget } from '../assets/modules/renderWidget';
import type Feature from '../core/modules/features/types/Feature';
import type Localiser from '../core/modules/Localiser';
import { Site } from '../core/modules/sites/Site';
import type { Translate } from '../core/types/Localiser';
import type { Widget } from '../core/types/Widget';
import { isServerside } from '../core/utils/isServerside';
import { AppInstance } from '../wss/types/AppInstance';

export type WindowHawk = {
  events: HawkEvent[];
  cache: Record<string, any>;
  renderWidget: typeof renderWidget;
  widgetMap: Widget[];
  widgetsLoading: number;
  widgetFeatures: Feature[];
  sites: Site[];
  localiser: Localiser;
  territory: string;
  version?: string;
  processWidget: typeof processWidget;
  articleId: string | null;
  articleType: string | null;
  keywords: string[] | null;
  articleName: string;
  articleUrl: string;
  site: Site;
  editorialOnPage: boolean;
  processedWidgets: ProcessedWidget[];
  gaCache: Record<string, string | number | null>;
  blockEditorWidgets: boolean;
  app: AppInstance;
  widgetsLoaded: boolean;
  translate: Translate;
};

type Scope = {
  hawk?: Partial<WindowHawk>;
};

export const getHawk = (): Partial<WindowHawk> => {
  const scope = (isServerside() ? global : window) as Scope;
  if (!scope.hawk) {
    scope.hawk = {};
  }
  return scope.hawk;
};

export const updateHawk = (params: Partial<WindowHawk>): void => {
  const hawk = getHawk();
  Object.assign(hawk, params);
  if (!isServerside()) {
    localStorage.setItem('hawk', JSON.stringify(hawk));
  }
};
